import styles from './styles.module.css';

type ReserveSectionHeadProps = {
  title?: string;
  children?: React.ReactNode;
  emptyTimesInfo?: boolean;
};

const ReserveSectionHead = ({
  title = 'ساعت‌های خالی',
  children,
  emptyTimesInfo = false,
}: ReserveSectionHeadProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>

      <div className={styles.left}>
        {children}
        {emptyTimesInfo && (
          <div className={styles.legend}>
            <span className={styles.legendItem}>
              <span className={styles.available} />
              خالی
            </span>

            <span className={styles.legendItem}>
              <span className={styles.reserved} />
              رزرو شده
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReserveSectionHead;
